// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__g58Pa","hidden":"styles_hidden__ta7bZ"};